import {connect} from "react-redux";
import ShopListComponent from "../components/ShopListComponent";
import Meta from "../../_data/models/Meta";
import {myShopsSelector} from "../selectors";
import {fetchShops} from "../middlewares";
import {Map} from "immutable";
import {shopsSelector} from "../../_data/selectors";
import {setMyShopsFilter} from "../actions";

const mapDispatchToProps = (dispatch, props) => {

    return {
        filterByName: (e) => {
            if (e.target.value.length > 2) {
                //dispatch(setMyShopsFilter({filter: e.target.value}));
            }
            dispatch(setMyShopsFilter({filter: e.target.value}));
        },

        loadMore: (meta: Meta) => {
            if (meta && meta.hasNext()) {
                dispatch(fetchShops(meta.cursor, meta.nextPage));
            }
        }
    };
};

const mapStateToProps = (state, props) => {

    let shops = shopsSelector(state).filter((shop) => {
        return myShopsSelector(state).ids.has(shop.id);
    });

    if (myShopsSelector(state).filter && myShopsSelector(state).filter.length > 0 ) {
        const filter: string = myShopsSelector(state).filter && myShopsSelector(state).filter.toLowerCase();
        shops = shops.filter((shop) => {
            return shop.name.toLocaleLowerCase().includes(filter);
        });
    }


    return {
        items: shops,
        loading: myShopsSelector(state).loading,
        meta: myShopsSelector(state).meta,
        errors: myShopsSelector(state).errors,
    };
};

const ShopListContainer = connect(mapStateToProps, mapDispatchToProps)(ShopListComponent);
export default ShopListContainer;


// WEBPACK FOOTER //
// ./app/client/shop/container/ShopListContainer.ts